import { NgModule } from '@angular/core';
import { CommonModule, DatePipe, NgOptimizedImage } from '@angular/common';
import { SpacerComponent } from './components/spacer/spacer.component';
import { TaskbarComponent } from './components/taskbar/taskbar.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { EnvironmentUrlPipe } from './pipes/environment-url.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { RichTextFontColorPipe } from './pipes/rich-text-font-color.pipe';
import { FontColorNameConverter } from './pipes/font-color-name-converter.pipe';
import { AdditionalResourceComponent } from './components/additionalResource/additionalResource.component';
import { TemplateHeaderComponent } from './components/template-header/template-header.component';
import {
  Grid,
  CTA,
  Showcase,
  PlainCopy,
  Input2,
  Icons2,
  Breadcrumb,
  JAMP,
  Card,
  Dropdown2,
  TextHeader,
  DdlAriaHideOuterDomModule
} from '@citi-gcg-173875/citi-common-ui';
import { SocialNetworkBtnsComponent } from './components/social-network-btns/social-network-btns.component';
import { ScrollUpComponent } from './components/scroll-up/scroll-up.component';
import { LazyLoadImageDirective } from './directives/lazy-load-image.directive';
import { MktCarousel3Component } from './components/mkt-carousel3/mkt-carousel3.component';
import { MktCarouselItemDirective } from './components/mkt-carousel3/mkt-carousel3-item.directive';
import { AdaFriendlyNamePipe } from './pipes/ada-friendly-name.pipe';
import { AltFriendlyNamePipe } from '../cards/mpp/friendly-text.pipe';
import { MktTabListComponent } from './components/mkt-tab-list/mkt-tab-list.component';
import { MktTabPanelComponent } from './components/mkt-tab-panel/mkt-tab-panel.component';
import { MktAccordionComponent } from './components/mkt-accordion/mkt-accordion.component';
import { MktAccordionSectionComponent } from './components/mkt-accordion/mkt-accordion-section/mkt-accordion-section.component';
import { CreditCardComponent } from './components/credit-card/credit-card.component';
import { FeatureCardComponent } from './components/feature-card/feature-card.component';
import { CardPlaceholderComponent } from './components/card-placeholder/card-placeholder.component';
import { CommonService, MktEventListnerService, OfferUtilService, PqpsUtilService } from './services';
import { CardHeadComponent } from './components/credit-card/components/card-head/card-head.component';
import { CardTitleComponent } from './components/credit-card/components/card-title/card-title.component';
import { CardButtonComponent } from './components/credit-card/components/card-button/card-button.component';
import { CardRatingComponent } from './components/credit-card/components/card-rating/card-rating.component';
import { CardLinksComponent } from './components/credit-card/components/card-links/card-links.component';
import { CardCrossComponent } from './components/credit-card/components/card-cross/card-cross.component';
import { ReviewsContainerComponent } from './components/reviews-container/reviews-container.component';
import { ShowcaseSinglePanelComponent } from './components/showcase-single-panel/showcase-single-panel.component';
// import { Card, CardFeatures, CardFigure } from '@citi-gcg-173875/citi-common-ui';
import { CardArtComponent } from './components/card-art/card-art.component';
import { FeaturedFlagComponent } from './components/featured-flag/featured-flag.component';
import { MktRouterLinkDirective } from './directives/mkt-router-link.directive'
// import { BrandingDropdown2 } from '@citi-gcg-173875/citi-branding/lib/branding/header/navigation3/dropdown2/dropdown2.module';
// import { CitiBrandingModule } from '@citi-gcg-173875/citi-branding';
import { GenericTemplateComponent } from './components/generic-template/generic-template.component';
import { MktModalComponent } from './components/mkt-modal/mkt-modal.component';
import { CdsCheckboxModule, CdsFormsModule, CdsFormField, CdsInputModule, CdsModalDialogModule, CdsRadioModule, CdsGridModule, CdsDropdownModule, CdsButtonModule } from '@citi-gcg-173875/citi-common-ui-cds';
import { ImageCacheDirective } from './directives/cache';
import { RafLinkExpiredComponent } from "../common/components/raf-link-expired/raf-link-expired.component";
import { MatListComponent } from './components/matlist/matList-section.component';
import { MktModal2Component } from './components/mkt-modal2/mkt-modal2.component';

const CDS_IMPORTS = [
  CdsModalDialogModule,
  CdsFormsModule,
  CdsInputModule,
  CdsRadioModule,
  CdsCheckboxModule,
  CdsGridModule,
  CdsDropdownModule,
  CdsButtonModule
]

const IMPORTS = [
  CommonModule,
  NgOptimizedImage,
  Grid,
  CTA,
  Showcase,
  PlainCopy,
  Input2,
  Icons2,
  Breadcrumb,
  // CopyB1_9,
  JAMP,
  Dropdown2,
  // Dropdown2_2Q20,
  Card,
  // CardFeatures,
  // CardFigure,
  // CitiBrandingModule,
  TextHeader,
  DdlAriaHideOuterDomModule,
  ...CDS_IMPORTS
];

const DECLARATIONS = [
  SpacerComponent,
  PageNotFoundComponent,
  TaskbarComponent,
  EnvironmentUrlPipe,
  SafeHtmlPipe,
  SafeUrlPipe,
  AdaFriendlyNamePipe,
  AltFriendlyNamePipe,
  RichTextFontColorPipe,
  FontColorNameConverter,
  AdditionalResourceComponent,
  TemplateHeaderComponent,
  SocialNetworkBtnsComponent,
  ScrollUpComponent,
  MktCarousel3Component,
  MktCarouselItemDirective,
  LazyLoadImageDirective,
  MktTabListComponent,
  MktTabPanelComponent,
  MktAccordionComponent,
  MktAccordionSectionComponent,
  CreditCardComponent,
  FeatureCardComponent,
  CardPlaceholderComponent,
  CardHeadComponent,
  CardTitleComponent,
  CardButtonComponent,
  CardRatingComponent,
  CardLinksComponent,
  CardCrossComponent,
  ReviewsContainerComponent,
  ShowcaseSinglePanelComponent,
  CardArtComponent,
  FeaturedFlagComponent,
  MktRouterLinkDirective,
  GenericTemplateComponent,
  RafLinkExpiredComponent,
  MktModalComponent,
  ImageCacheDirective,
  MatListComponent,
  MktModal2Component
];

const PROVIDERS = [
  CommonService,
  OfferUtilService,
  PqpsUtilService,
  MktEventListnerService,
  AdaFriendlyNamePipe,
  CdsFormField,
  DatePipe
]

@NgModule({
  imports: [
    ...IMPORTS
  ],
  declarations: [
    ...DECLARATIONS,
  ],
  exports: [
    ...IMPORTS,
    ...DECLARATIONS
  ],
  providers: [
    ...PROVIDERS
  ]
})
export class MktCommonModule { }
